import React from 'react'

const Dsw15 = () => {
    return (
        <div className='container'>
            <h1>Copy set bits in a range</h1>
            <p>Given two numbers x and y, and a range [l, r] where 1 &lt;= l, r &lt;= 32. The task is consider set bits of y in range [l, r] and set these bits in x also.
Examples :</p>
<pre>Input  : x = 10, y = 13, l = 2, r = 3 <br />
Output : x = 14 <br />
Binary representation of 10 is 1<strong>01</strong>0 and  <br />
that of y is 1<strong>10</strong>1. There is one set bit <br />
in y at 3’rd position (in given range).  <br />
After we copy this bit to x, x becomes 1<strong>11</strong>0 <br />
which is binary representation of 14. <br />
 <br />
Input  : x = 8, y = 7, l = 1, r = 2 <br />
Output : x = 11 <br />
</pre>
<p><strong>Solution (One by one copy bits)</strong><br/>
We can one by one find set bits of y by traversing given range. For every set bit, we OR it to existing bit of x, so that the becomes set in x, if it was not set. Below is C++ implementation.</p>

        <div class="tabs">
           <input type="radio" name="tab" id="tab1" />
           <label for="tab1">CPP</label>
  
         
           <div class="tab-content-wrapper">
             <div id="tab-content-1" class="tab-content">
             <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C++ program to rearrange array in alternating</code>
    </div>
    <div class="line number2 index1 alt1"><code class="comments">// C++ program to copy set bits in a given</code></div>
    <div class="line number3 index2 alt2"><code class="comments">// range [l, r] from y to x.</code></div>
    <div class="line number4 index3 alt1"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
    <div class="line number5 index4 alt2"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number7 index6 alt2 highlighted"><code
            class="comments">// Copy set bits in range [l, r] from y to x.</code></div>
    <div class="line number8 index7 alt1 highlighted"><code
            class="comments">// Note that x is passed by reference and modified</code></div>
    <div class="line number9 index8 alt2 highlighted"><code class="comments">// by this function.</code></div>
    <div class="line number10 index9 alt1 highlighted"><code class="keyword bold">void</code> <code
            class="plain">copySetBits(unsigned &amp;x, unsigned y,</code></div>
    <div class="line number11 index10 alt2 highlighted"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">unsigned l, unsigned r)</code></div>
    <div class="line number12 index11 alt1 highlighted"><code class="plain">&#123;</code></div>
    <div class="line number13 index12 alt2 highlighted"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// l and r must be between 1 to 32</code></div>
    <div class="line number14 index13 alt1 highlighted"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// (assuming ints are stored using</code></div>
    <div class="line number15 index14 alt2 highlighted"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">//&nbsp; 32 bits)</code></div>
    <div class="line number16 index15 alt1 highlighted"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(l &lt; 1 || r &gt; 32)</code></div>
    <div class="line number17 index16 alt2 highlighted"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keyword bold">return</code>
        <code class="plain">;</code></div>
    <div class="line number18 index17 alt1 highlighted"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number19 index18 alt2 highlighted"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Travers in given range</code></div>
    <div class="line number20 index19 alt1 highlighted"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i=l; i&lt;=r; i++)</code></div>
    <div class="line number21 index20 alt2 highlighted"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number22 index21 alt1 highlighted"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Find a mask (A number whose</code></div>
    <div class="line number23 index22 alt2 highlighted"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// only set bit is at i'th position)</code></div>
    <div class="line number24 index23 alt1 highlighted"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">mask = 1 &lt;&lt; (i-1);</code></div>
    <div class="line number25 index24 alt2 highlighted"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number26 index25 alt1 highlighted"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If i'th bit is set in y, set i'th</code></div>
    <div class="line number27 index26 alt2 highlighted"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// bit in x also.</code></div>
    <div class="line number28 index27 alt1 highlighted"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(y &amp; mask)</code></div>
    <div class="line number29 index28 alt2 highlighted"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">x = x | mask;</code></div>
    <div class="line number30 index29 alt1 highlighted"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number31 index30 alt2 highlighted"><code class="plain">&#125;</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="comments">// Driver code</code></div>
    <div class="line number34 index33 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number35 index34 alt2"><code class="plain">&#123;</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="plain">unsigned x = 10, y = 13, l = 2, r = 3;</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="plain">copySetBits(x, y, l, r);</code></div>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Modified x is "</code> <code
            class="plain">&lt;&lt; x;</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;&nbsp;</code></div>
    <div class="line number40 index39 alt1"><code class="plain">&#125;</code></div>
</div>
           </div>
           
            </div>
         </div>
         <br /> <br /> <br /> <br /> <br />
               </div>
    )
}

export default Dsw15
